import { useEffect } from 'react';
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from 'react-redux';

import { checkAddressAsString } from 'reducers/addressReducer';
import { decodeAddressParam } from 'utils/addressUtils';
import useFallbackPolling from 'hooks/useFallbackPolling';

// import './PropertyContainer.css';

const PropertyContainer = ({ children }) => {
	const dispatch = useDispatch();
	let { address } = useParams();

	const {
		propertyId,
		isLoadingProperty,
	} = useSelector(state => ({
		propertyId: state.property.propertyData?.id,
		isLoadingProperty: state.property.isLoading,
	}));

	useEffect(() => {
		let decodedAddress = decodeAddressParam(address);
		if (decodedAddress && !propertyId && !isLoadingProperty) {
			dispatch(checkAddressAsString(decodedAddress));
		}
	}, [address, propertyId, isLoadingProperty, dispatch]);

	useFallbackPolling(propertyId);

	return children;
};

export default PropertyContainer;
